import { Component, Inject, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MaterialSharedModule } from '@app/shared/modules/material-shared.module';
import { TranslateService } from '@ngx-translate/core';

export interface ConfirmationDialogData {
  title: string;
  message: string;
  iconName: string;
  confirmButtonText: string;
  cancelButtonText?: string;
  confirmButtonColor?: 'primary' | 'warn';
  /** Hide the cancel button for informational-only dialogs */
  hideCancelButton?: boolean;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MaterialSharedModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData,
    private translate: TranslateService
  ) {
    // Set defaults if not provided
    if (!this.data.hideCancelButton) {
      this.data.cancelButtonText = this.data.cancelButtonText || this.translate.instant('confirmationDialog.cancel');
    }
    this.data.confirmButtonColor = this.data.confirmButtonColor || 'primary';
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
